import { useState } from 'react';
import { useSelector } from 'react-redux';
import AgsExportConfigurationLaboratoryAdmin from './Core/AgsExportConfigurationLaboratoryAdmin';
import { AgsExportConfigurationDeleteDialogAdmin } from './Core/AgsExportConfigurationDeleteDialogAdmin';
import AgsExportConfigurationSectionAdmin from './Core/AgsExportConfigurationSectionAdmin';
import { IAgsExportConfigurationsAgsVersion, IAgsLaboratorySettings } from './types';

const AgsExportConfigurationListAdmin = () => {
  const agsVersions: IAgsExportConfigurationsAgsVersion[] = useSelector(
    (state: any) => state.admin.syncModel.AgsVersions ?? []
  ) as IAgsExportConfigurationsAgsVersion[];

  const agsLaboratoryMappings: IAgsLaboratorySettings[] = useSelector(
    (state: any) => state.admin.syncModel.LaboratoryMappings ?? []
  ) as IAgsLaboratorySettings[];

  const agsDefaultConfigurationMapping: IAgsLaboratorySettings = useSelector(
    (state: any) => state.admin.syncModel.DefaultConfigurationMapping
  ) as IAgsLaboratorySettings;

  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [deleteConfigurationId, setDeleteConfigurationId] = useState('');

  if (agsVersions.length === 0) {
    return null;
  }

  const agsExportConfigurationDeleteDialog = (configurationId: string) => {
    setDeleteDialogVisible(true);
    setDeleteConfigurationId(configurationId);
  };

  const onCloseDeleteDialog = () => {
    setDeleteDialogVisible(false);
    setDeleteConfigurationId('');
  };

  return (
    <>
      {agsVersions.map((agsVersion) => (
        <AgsExportConfigurationSectionAdmin
          agsVersion={agsVersion}
          agsExportConfigurationDeleteDialog={agsExportConfigurationDeleteDialog}
          key={agsVersion.AgsVersion}
        />
      ))}
      <AgsExportConfigurationLaboratoryAdmin
        agsLaboratoryMappings={agsLaboratoryMappings}
        configurations={agsVersions}
        agsDefaultConfigurationMapping={agsDefaultConfigurationMapping}
      />
      <AgsExportConfigurationDeleteDialogAdmin
        dialogVisibleState={deleteDialogVisible}
        agsExportConfigurationId={deleteConfigurationId}
        onClose={onCloseDeleteDialog}
      />
    </>
  );
};

export default AgsExportConfigurationListAdmin;
export { AgsExportConfigurationListAdmin };
